import { connect } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import Page from "./loadable";

export default connect((state) => ({
  masterId: UserSelectors.getMasterId(state),
  isBusinessMode: UserSelectors.isBusinessMode(state),
}))(Page);
